import { render, staticRenderFns } from "./InformationCard.vue?vue&type=template&id=24044d61&scoped=true"
import script from "./InformationCard.vue?vue&type=script&lang=js"
export * from "./InformationCard.vue?vue&type=script&lang=js"
import style0 from "./InformationCard.vue?vue&type=style&index=0&id=24044d61&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24044d61",
  null
  
)

export default component.exports